const breakpointMap = {
  desktop: '1024px',
  large: '1400px',
}

const theme = {
  breakpoints: Object.values(breakpointMap),
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64],
  space: [0, 4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 64, 128, 256],
  fonts: {
    sans: 'Larsseit-Bold, system-ui, sans-serif',
    serif: 'AdrianeText, georgia',
    mono: 'Menlo, monospace',
  },
  colors: {
    black: '#010101',
    white: '#fff',
    grey: '#e9e9e9',
    yellow: '#fffcef',
    red: '#FF0000',
  },
}

export { theme, breakpointMap }
